import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

export function dailyReportPromptMessage(clientName) {
  const name = String(clientName || "").trim() || "this client"
  return `Would you like to add session notes for ${name} before you go?`
}

export default function DailyReportPromptDialog({
  open,
  clientName,
  onYes,
  onNo,
}) {
  return (
    <Dialog
      open={open}
      onClose={onNo}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      sx={{ zIndex: 2000 }}
    >
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Typography variant="body1">
          {dailyReportPromptMessage(clientName)}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button variant="outlined" color="primary" onClick={onNo}>
          No
        </Button>
        <Button variant="contained" color="primary" onClick={onYes} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
